var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4107 6.89655C15.5132 2.82759 12.1798 0 8.33355 0C3.71804 0 0 4 0 8.96552C0 13.6552 3.39752 17.5172 7.6925 17.8621V21.3103C7.6925 21.7241 7.94892 22 8.33355 22C8.71817 22 8.97459 21.7241 8.97459 21.3103V14V11.4483L11.9875 8.2069C12.2439 7.93104 12.2439 7.51724 11.9875 7.24138C11.7311 6.96552 11.3464 6.96552 11.09 7.24138L8.97459 9.58621V7.51724L6.85915 5.24138C6.60273 4.96552 6.21811 4.96552 5.96169 5.24138C5.70527 5.51724 5.70527 5.93104 5.96169 6.2069L7.6925 8.06897V12.3448L5.25654 9.72414C5.00013 9.44828 4.6155 9.44828 4.35909 9.72414C4.10267 10 4.10267 10.4138 4.35909 10.6897L7.6925 14.2759V16.4828C4.10267 16.1379 1.28208 12.8966 1.28208 8.96552C1.28208 4.75862 4.42319 1.37931 8.33355 1.37931C12.2439 1.37931 15.385 4.75862 15.385 8.96552C15.385 12.3448 13.2696 15.3103 10.2567 16.2759V17.7241C14.744 16.5517 17.5004 11.7241 16.4107 6.89655Z",
    fill: "#898989",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndex);
export default __webpack_public_path__ + "static/media/index.dd6bb0fa.svg";
export { ForwardRef as ReactComponent };